import React, { createContext, useContext, useEffect, useState } from 'react';
import { getSystemConfig } from '../services/firebase';
import { SystemConfig } from '../types';

interface SystemContextType {
  config: SystemConfig | null;
  loading: boolean;
  refreshConfig: () => Promise<void>;
  getPayPalClientId: () => string | null;
}

const SystemContext = createContext<SystemContextType>({
  config: null,
  loading: true,
  refreshConfig: async () => {},
  getPayPalClientId: () => null,
});

export const useSystem = () => useContext(SystemContext);

export const SystemProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<SystemConfig | null>(null);
  const [loading, setLoading] = useState(true);

  const refreshConfig = async () => {
    const data = await getSystemConfig();
    setConfig(data);
  };

  useEffect(() => {
    const init = async () => {
      await refreshConfig();
      setLoading(false);
    };
    init();
  }, []);

  const getPayPalClientId = () => {
    if (!config) return null;
    return config.paypalMode === 'production' 
      ? config.paypalProductionClientId 
      : config.paypalSandboxClientId;
  };

  return (
    <SystemContext.Provider value={{ config, loading, refreshConfig, getPayPalClientId }}>
      {children}
    </SystemContext.Provider>
  );
};